import User from "./User";
import Axios from "axios";
import moment from "moment";
import Vue from "vue";
import store from "../src/store";

class BillboardClass {

  constructor() {
    this.postsPublished = /** @type {BillboardPost[]} */ ([]);
    this.postsPending = /** @type {BillboardPost[]} */ ([]);
    this.pagesPublished = 0;
    this.pagesPending = 0;
    this.countPublised = 0;
    this.countPending = 0;
    this.pagination = 3;
    this.loading = false;
  }

  /**
   * @param {number} id
   */
  get(id) {
    for (let post of [...this.postsPublished, ...this.postsPending]) {
      if (post.id == id) {
        return post;
      }
    }
    return null;
  }

  async init() {
    if (!User.token) {
      return;
    }
    this.loadPage(true, 1);
    this.loadPage(false, 1);
  }

  /**
   * @param {boolean} published
   * @param {number} page
   */
  getPage(published, page) {
    let toReturnFrom = published ? this.postsPublished : this.postsPending;
    return toReturnFrom.slice((page - 1) * this.pagination, page * this.pagination);
  }

  /**
   * @param {boolean} published
   * @param {number} page Page to load, starting at 1
   */
  async loadPage(published, page) {
    let url;
    let toPushTo = published ? this.postsPublished : this.postsPending;
    while (toPushTo.length < page * this.pagination) {
      toPushTo.push(new BillboardPost());
    }
    if (published) {
      url = CONFIG.urlServer + "/api/posts?status[]=published";
    } else {
      url = CONFIG.urlServer + "/api/posts?author=" + User.id + "&status[]=pending&status[]=accepted&status[]=rejected";
    }
    let posts = await Axios.get(url, {
      params: {
        property: store.state.property,
        perPage: this.pagination,
        page: page
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    for (let i = 0; i < posts.data.data.length; i++) {
      let post = new BillboardPost().load(posts.data.data[i]);
      Vue.set(toPushTo, (page - 1) * this.pagination + i, post);
    }
    if (posts.data.count < toPushTo.length) {
      if (published) {
        this.postsPublished = toPushTo.slice(0, posts.data.count);
      } else {
        this.postsPending = toPushTo.slice(0, posts.data.count);
      }
    }
    if (published) {
      this.countPublised = posts.data.count;
      this.pagesPublished = Math.max(Math.ceil(posts.data.count / this.pagination), 1);
    } else {
      this.countPending = posts.data.count;
      this.pagesPending = Math.max(Math.ceil(posts.data.count / this.pagination), 1);
    }
  }

  /**
   * @param {string} title
   * @param {string} subTitle
   * @param {string} body
   * @param {string} start
   * @param {string} end
   * @param {{data: string, name: string, type: string, extension: string}} imageData
   */
  async createPost(title, subTitle, body, start, end, imageData) {
    return await Axios.post(CONFIG.urlServer + "/api/posts", {
      title: {
        fr: title,
        en: ""
      },
      subTitle: {
        fr: subTitle,
        en: ""
      },
      body: {
        fr: body,
        en: ""
      },
      organization: store.state.organization,
      startAt: moment(start).format("YYYY-MM-DD HH:mm:ss"),
      endAt: moment(end).format("YYYY-MM-DD HH:mm:ss"),
      status: "pending",
      image: imageData
        ? {
          file: imageData.data.split("base64,")[1],
          mediaType: imageData.type,
          extension: imageData.extension,
        }
        : null
    }, {
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
  }
  async removePost(post) {
    let result = await Axios.put(CONFIG.urlServer + "/api/posts/" + post.id, {
      status: post.status
    }, {
      params: {
        property: store.state.property
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    return result;
  }


}

/**
 * @typedef BillboardPostDefinition
 * @property {number} id
 * @property {{fr: string, en: string}} title
 * @property {{fr: string, en: string}} subTitle
 * @property {{fr: string, en: string}} body
 * @property {string} createdAt
 * @property {string} status
 * @property {string} decisionNote
 * @property {number} author
 * @property {{id: number, url: string, name: string, tag: string}} [image]
 */

export class BillboardPost {

  /**
   * @param {BillboardPostDefinition} definition
   */
  load(definition) {
    this.id = definition.id;
    this.title = definition.title;
    this.subTitle = definition.subTitle;
    this.body = definition.body;
    this.createdAt = moment(definition.createdAt);
    this.image = definition.image ? definition.image.url : null;
    this.status = definition.status;
    this.decisionNote = definition.decisionNote;
    this.author = definition.author;
    return this;
  }

}

let Billboard = new BillboardClass();
export default Billboard;